import React from 'react'
import PropTypes from 'prop-types'

import { YES_NO_OPTIONS } from 'utils/enums/questions'
import { FormRadioButtonGroup } from 'components/form/radioButtonGroup/FormRadioButtonGroup'
import { validateRequiredField } from 'utils/helpers/validators/byType/requiredField'

import styles from '../FormByState.module.scss'

export const CtFormConfig = {
  wasSubjectOfAbuse: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasResigned: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasLicenseRevoked: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
}

export const CTForm = ({ formData, handleFieldChange }) => (
  <div className={styles.form}>
    <FormRadioButtonGroup
      title="Has applicant ever been the subject of an abuse or neglect or sexual misconduct investigation by any employer, state agency or municipal police department (answer “no” if the investigation resulted in a finding that all allegations were unsubstantiated)?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasSubjectOfAbuse}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Has applicant ever been disciplined or asked to resign from employment or resigned from or otherwise separated from any employment while an allegation of abuse or neglect was pending or under investigation by the Department of Children and Families (the “department”), or an allegation of sexual misconduct was pending or under investigation or due to an allegation substantiated pursuant to section 17a-101g of abuse or neglect, or of sexual misconduct or a conviction for abuse or neglect or sexual misconduct?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasResigned}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Has applicant ever had a professional or occupational license or certificate suspended or revoked or ever surrendered such a license or certificate while an allegation of abuse or neglect was pending or under investigation by the department or an investigation of sexual misconduct was pending or under investigation, or due to an allegation substantiated by the department of abuse or neglect or of sexual misconduct or a conviction for abuse or neglect or sexual misconduct?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasLicenseRevoked}
      handleFieldChange={handleFieldChange}
    />
  </div>
)

CTForm.propTypes = {
  formData: PropTypes.object.isRequired,
  formMeta: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
